/*
*    <div data-module-reward id="reward">
*        Freebees : <span id="reward-freebees"></span><br>
*        Randollars : <span id="reward-randollars"></span><br>
*        Total : <span id="reward-total"></span><br>
*    </div>
*/
import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let input_elements = this.el.querySelector('#freebees_amount');
        input_elements.addEventListener("change", function() {
            let fd = new FormData();
            fd.append('total', snipcartState.cart.total);
            fd.append('card',snipcartState.cart.billingAddress.company);
            fd.append('items',JSON.stringify(snipcartState.cart.items.items));
            fetch('/wp-json/freebees/v1/reward',{method: "POST",body: fd})
            .then(response => response.json())
            .then(data => { 
                if(!data.success){
                    console.log(data.data);
                } else {
                    try{
                        document.getElementById('reward-randollars').innerHTML = data.data/100;
                    } catch(e) {}
                }
            });
        });

        Snipcart.events.on('snipcart.initialized', (snipcartState) => {
            let card = snipcartState.cart.billingAddress.company; //Carte par default
            let fd = new FormData();
            fd.append('total', snipcartState.cart.total);
            fd.append('card',card);
            fd.append('items',JSON.stringify(snipcartState.cart.items.items));
            fetch('/wp-json/freebees/v1/reward',{method: "POST",body: fd})
            .then(response => response.json())
            .then(data => { 
                if(!data.success){
                    console.log(data.data);
                } else {
                    try{
                        document.getElementById('reward-randollars').innerHTML = data.data/100;
                    } catch(e) {}
                }
            });
        });
    }
}
